module.exports = __webpack_public_path__ + "static/media/474SunsetAveNW_2018-06-06_61.6f458327.jpg";